module.exports = __webpack_public_path__ + "font_uzura_daughter.3f7912e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_uzura_daughter.png
// module id = k6II
// module chunks = 0